// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { StoresInstance } from "Globals/Stores";

// Dto
import { SupportingInformationModel } from "./SupportingInformationModel";
import { SupportingInformationDTO } from "Globals/Models/DTO/SupportingInformationDTO";

export class ParentSupportingInformationModel extends ModelBase<ParentSupportingInformationModel> {
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public reportsRequired: boolean = false;

    @MobX.observable public supportingInformationModels: SupportingInformationModel[] = [];

    @MobX.action
    public fromDto = (model: SupportingInformationDTO[]): void => {
        if (model !== null && model !== undefined) {
            model.forEach((supinfo) => {
                let localSupportingInformationModels: SupportingInformationModel = new SupportingInformationModel();
                localSupportingInformationModels.fromDto(supinfo);
                this.supportingInformationModels.push(localSupportingInformationModels);
            });
        }
    };
    @MobX.action
    public toDto = (): boolean => {
        return true;
    };
}
